module.exports = __webpack_public_path__ + "media/custom/images/img16-3690aa63822569fcaf8018f23efdca10.png";